import type {
  PropertySelectionRow,
  RequestedPicturesPlotDataResponse,
} from "../../types";
import { convertRequestedPicturesToPropertyRow } from "./convertRequestedPicturesToPropertyRow";
import { generateNextId } from "../propertySelection/generateNextId";
import { selectExistingRow } from "../propertySelection/selectExistingRow";

/**
 * 新しい行を追加してcurrentPopupRowIdを設定する
 * @param properties 現在のプロパティ配列
 * @param plot 追加するプロットデータ
 * @param setCurrentPopupRowId currentPopupRowId設定関数
 * @returns 更新されたプロパティ配列
 */
export const addNewRowAndSelect = (
  properties: PropertySelectionRow[],
  plot: RequestedPicturesPlotDataResponse,
  setCurrentPopupRowId?: React.Dispatch<React.SetStateAction<number | null>>
): PropertySelectionRow[] => {
  const nextId = generateNextId(properties);
  const newRow = convertRequestedPicturesToPropertyRow(plot, nextId, []);

  selectExistingRow(nextId, setCurrentPopupRowId);

  return [...properties, newRow];
};
